import src from "IMAGE";
export default { src, width: 83, height: 66, blurWidth: 0, blurHeight: 0};
